import Vue from "vue";
import Vuex from "vuex";
import basic from "./basic";
const hot = {
    namespaced: true,
    state: {
      otherObj: {},
      listObj: {},
  
    },
    getters: {
      otherObj: (state) => state.otherObj,
      listObj: (state) => state.listObj,
    },
    mutations: {
      updateData(state, data) {
        for (const key in data) {
          state[key] = data[key];
        }
      },
    },
    actions: {},
  };
Vue.use(Vuex);


  export default new Vuex.Store({
    modules: {
      basic,
      hot
    },
  });
  